import { render, staticRenderFns } from "./vfg-field-custom-richtext.vue?vue&type=template&id=28b1366c&scoped=true"
import script from "./vfg-field-custom-richtext.vue?vue&type=script&lang=js"
export * from "./vfg-field-custom-richtext.vue?vue&type=script&lang=js"
import style0 from "./vfg-field-custom-richtext.vue?vue&type=style&index=0&id=28b1366c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1366c",
  null
  
)

export default component.exports